module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "klickbox-edit-title"
  }, [_vm._v(_vm._s(_vm.$t('edit.canvas.next_button_text')))]), _vm._v(" "), _c('input', {
    staticClass: "btn",
    staticStyle: {
      "padding-top": "25px",
      "margin-top": "-20px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.step.next_button_text || _vm.$t('general.labels.next')
    },
    on: {
      "change": function($event) {
        return _vm.stepUpdateNextButtonText({
          event: $event,
          id: _vm.step.id
        })
      }
    }
  })])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-5094301f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/step/NextButton.vue
 ** module id = 824
 ** module chunks = 1
 **/